import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../services/api.js';

/** Registra visitas de páginas públicas (no admin). */
export function usePageViewAnalytics() {
  const { pathname } = useLocation();
  const lastPath = useRef('');

  useEffect(() => {
    if (!pathname || pathname.startsWith('/admin')) {
      return;
    }
    if (pathname === lastPath.current) {
      return;
    }
    lastPath.current = pathname;

    const referrer = typeof document !== 'undefined' ? document.referrer : '';
    api
      .post('/v1/public/analytics/view', {
        path: pathname,
        referrer: referrer || undefined,
      })
      .catch(() => {
        /* no bloquear navegación */
      });
  }, [pathname]);
}
